import { render, staticRenderFns } from "./UserGroupPrivileges.vue?vue&type=template&id=d814c344&scoped=true"
import script from "./UserGroupPrivileges.vue?vue&type=script&lang=js"
export * from "./UserGroupPrivileges.vue?vue&type=script&lang=js"
import style0 from "./UserGroupPrivileges.vue?vue&type=style&index=0&id=d814c344&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d814c344",
  null
  
)

export default component.exports